import { Editor, EditorContent } from "tiptap";

export default {
  name: "tipTapDisplay",
  props: { contentJSON: Object },
  components: {
    EditorContent,
  },
  data() {
    return {
      editor: null,
    };
  },
  mounted() {
    this.editor = new Editor({
      editable: false,
      content: this.contentJSON,
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  watch: {
    contentJSON: function(newContent) {
      this.editor.setContent(newContent);
    },
  },
};
